<template>
    <div style="display: block; margin:auto; font-size: 20px; margin-top: 100px; text-align: center;">
        注册后登录就行，没那么复杂
    </div>
</template>

<script>
export default {
    name: 'help',
    data() {
        return {
            msg: '这是help页面'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/html/help.vue